<template>
    <a-card style="margin-top: 16px">
        <template #title>
            <span style="font-size: 14px">存款信息</span>
        </template>

        <a-form-model
            ref="form"
            v-bind="formLayout"
            :model="form"
            :rules="formRules"
        >
            <a-row>
                <a-col :span="12">
                    <a-form-model-item label="存缴金额" prop="cashPaymentAmount">
                        <a-input-number
                            v-model="form.cashPaymentAmount"
                            :precision="2"
                            placeholder="请输入金额"
                            style="width: 320px"
                        />
                    </a-form-model-item>
                </a-col>
                <a-col :span="12">
                    <a-form-model-item label="缴纳时间" prop="cashPaymentDate">
                        <a-date-picker
                            v-model="form.cashPaymentDate"
                            value-format="YYYY-MM-DD"
                            :disabled-date="getDisabledDate"
                            style="width: 320px"
                        />
                    </a-form-model-item>
                </a-col>
            </a-row>
            <a-row>
                <a-col :span="12">
                    <a-form-model-item label="缴纳凭证" prop="cashFile">
                        <custom-upload-file v-model="form.cashFile" />
                    </a-form-model-item>
                </a-col>
                <a-col :span="12">
                    <a-form-model-item label="存款协议书" prop="depositGreementFile">
                        <custom-upload-file v-model="form.depositGreementFile" />
                    </a-form-model-item>
                </a-col>
            </a-row>
        </a-form-model>

        <custom-portal :to="portalTo">
            <a-button
                type="primary"
                :loading="saving"
                @click.stop="handleSure"
            >
                确定
            </a-button>
        </custom-portal>
    </a-card>
</template>
<script>
import {
    Row as ARow,
    Col as ACol,
    Card as ACard,
    Button as AButton,
    FormModel as AFormModel,
    DatePicker as ADatePicker,
    InputNumber as AInputNumber
} from 'ant-design-vue'
import CustomPortal from '@components/CustomPortalVue/Portal'
import CustomUploadFile from '@weights/CreateForm/components/UploadFile'

import { dateUtil } from '4d-space-bag'
import formatDate from '@utils/formatDate'

import { BANK_CONNECTION_STATUS_NORMAL } from '@constant/enum'

import saveService from '@service/marginManagement/marginPaymentDetail/saveCashPaymentRecordService'

const FORM_FIELDS = [
    'id',
    'orderNo',
    'cashFile',
    'cashPaymentDate',
    'cashPaymentAmount',
    'depositGreementFile'
]

function generateFormRules() {
    const rules = {}

    const len = FORM_FIELDS.length
    for (let i = 2; i < len; i++) {
        rules[FORM_FIELDS[i]] = [
            {
                required: true,
                message: '此项为必填'
            }
        ]
    }

    return rules
}

function copyValues(values) {
    const newValues = {}

    FORM_FIELDS.forEach(field => {
        newValues[field] = values[field]
    })

    return newValues
}

export const PORTAL_KEY = 'DepositInfoPanel'

export default {
    name: 'DepositInfoPanel',
    components: {
        ARow,
        ACol,
        ACard,
        AButton,
        AFormModel,
        ADatePicker,
        AInputNumber,
        CustomPortal,
        CustomUploadFile,
        AFormModelItem: AFormModel.Item
    },
    props: {
        initialValues: Object
    },
    data() {
        return {
            portalTo: PORTAL_KEY,

            saving: false,
            form: {},
            formLayout: {
                labelCol: {
                    span: 4
                },
                wrapperCol: {
                    span: 18
                }
            },
            formRules: generateFormRules()
        }
    },
    computed: {
        // 银行直连状态
        connectionStatus() {
            return this.initialValues.connectionStatus
        },
        // 银行余额
        currentBalance() {
            return +this.initialValues.currentBalance || 0
        },
        // 当前填入的金额（存缴金额）
        amountEntered() {
            return +this.form.cashPaymentAmount || 0
        },
        // 当前填入的金额（存缴金额）是否 小于或等于 银行余额
        isValidAmountEntered() {
            return this.amountEntered <= this.currentBalance
        },
        // 银行直连状态是否为 正常
        isNormalConnectionStatus() {
            return this.connectionStatus === BANK_CONNECTION_STATUS_NORMAL
        }
    },
    watch: {
        initialValues: {
            handler(obj) {
                this.form = copyValues(obj || {})
            },
            deep: true,
            immediate: true
        }
    },
    methods: {
        // 提交表单
        async handleSubmit() {
            try {
                this.saving = true
                await saveService(this.form)

                this.$emit('on-ok')
                this.$message.success('操作成功')
            } catch (e) {
                this.$message.warning(e.message)
                this.$captureException(e)
            } finally {
                this.saving = false
            }
        },
        // 禁用今天之后的日期
        getDisabledDate(currentDate) {
            return dateUtil.compareTime(formatDate(currentDate), new Date()) < 0
        },
        // 确定
        handleSure() {
            this.$refs.form.validate(valid => {
                if (!valid) return

                /**
                 * 当银行直连状态是否为 正常 时
                 * 需要校验当前填入的金额（存缴金额）是否 大于 银行余额
                 */
                // if (this.isNormalConnectionStatus && !this.isValidAmountEntered) {
                //     this.$message.warning('银行余额小于填入金额，请确认')
                //     return
                // }

                this.handleSubmit()
            })
        }
    }
}
</script>
